<template lang="html">
  <div>
    <div style="padding: 0 2em 2em"> 
      <h4>Props for Modal component and for new modal options</h4>
      <table class="uk-table uk-table-divider uk-table-small uk-table-striped">
          <thead>
              <tr>
                  <th>Property</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Accepted</th>
                  <th>Description</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(prop, index) in properties" :key="index">
                  <td class="uk-width-small">{{prop.name}}</td>
                  <td class="uk-width-small"><small>{{prop.type}}</small></td>
                  <td class="uk-width-small">{{prop.default}}</td>
                  <td class="uk-width-small">{{prop.accepted}}</td>
                  <td>{{prop.description}}</td>
              </tr>
          </tbody>
      </table>
    </div>

    <div style="padding: 0 2em 2em"> 
      <h4>Add props for new modal options</h4>
      <table class="uk-table uk-table-divider  uk-table-small">
          <thead>
              <tr>
                  <th>Property</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Accepted</th>
                  <th>Description</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(prop, index) in addProperties" :key="index">
                  <td class="uk-width-small">{{prop.name}}</td>
                  <td class="uk-width-small"><small>{{prop.type}}</small></td>
                  <td class="uk-width-small">{{prop.default}}</td>
                  <td class="uk-width-small">{{prop.accepted}}</td>
                  <td>{{prop.description}}</td>
              </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'props-page',
  data() {
    return {
      addProperties: [
        {
          name: 'component',
          description: '',
          default: 'is required',
          type: 'Vue component',
          accepted: ''
        },
        {
          name: 'onDismiss',
          description: '',
          default: '-',
          type: 'Function',
          accepted: ''
        },
        {
          name: 'onClose',
          description: '',
          default: '-',
          type: 'Function',
          accepted: ''
        },
      ],
      properties: [
        {
          name: 'title',
          description: '',
          default: '-',
          type: 'String',
          accepted: ''
        },
        {
          name: 'size',
          description: '',
          default: 'md',
          type: 'String',
          accepted: 'xs, sm, md, lg, xl, p50, p70, p90'
        },
        {
          name: 'className',
          description: '',
          default: '-',
          type: 'String',
          accepted: ''
        },
        {
          name: 'fullscreen',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'center',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'isScroll',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'isTop',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'isBottom',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'isLeft',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'isRight',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'escapable',
          description: '',
          default: 'false',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'dismissable',
          description: '',
          default: 'true',
          type: 'Boolean',
          accepted: ''
        },
        {
          name: 'bodyPadding',
          description: '',
          default: 'true',
          type: 'Boolean',
          accepted: ''
        }
      ]
    }
  }
};
</script>


// WEBPACK FOOTER //
// props.vue?613d70ef